import React from 'react';

import {cls} from '../utils';
import {FormulaResult, keptIndexes} from './dice-formula';
import {DiceChip} from './dice-shape';

import css from './dice.module.css';

type Props = {
	result: FormulaResult;
};

const sign = (value: number, isFirst: boolean) => (value < 0 ? '−' : isFirst ? '' : '+');

/** выпавшие кости по группам формулы, модификатор и итог */
export const DiceResult: React.FC<Props> = ({result}) => (
	<span className={css.result}>
		<span className={css.resultGroups}>
			{result.groups.map((group, groupIndex) => {
				const kept = keptIndexes(group.term, group.values);
				return (
					<span key={groupIndex} className={css.resultGroup}>
						{sign(group.subtotal, groupIndex === 0) && (
							<span className={css.groupSign}>{sign(group.subtotal, groupIndex === 0)}</span>
						)}
						{group.values.map((value, valueIndex) => (
							<span key={valueIndex} className={cls(!kept.has(valueIndex) && css.droppedDie)}>
								<DiceChip sides={group.term.sides} value={value} />
							</span>
						))}
						{group.term.keep && (
							<span className={css.groupNote}>{group.term.keep.highest ? 'лучшая' : 'худшая'}</span>
						)}
					</span>
				);
			})}
			{result.modifier !== 0 && (
				<span className={css.resultGroup}>
					<span className={css.groupSign}>{result.modifier > 0 ? '+' : '−'}</span>
					<span>{Math.abs(result.modifier)}</span>
				</span>
			)}
		</span>
		<span className={css.total}>= {result.total}</span>
	</span>
);
